export const COPY_TEXT =
  'Attend at least one of these two meetings to earn your certificate of completion'
